<template>
 <div class="popup" v-cloak v-if="verifiSettingShow">
     <div class="content" id="verificationSet" :style={height:getheight()}>
           <div class="title">
                  {{$t('language.twoStepverification.verifySet')}}
                 <div class="icon white-close dialog-close" @click="closePage()"></div>
           </div>
           <div class="set-body-content" v-if="stepOneShow">
               <div style="width:100%;height:calc(100% - 30Px);float:left;">
                <div style="float:left;height:35Px;width:100%;fontSize:14Px;">
                {{$t('language.twoStepverification.addWayVerify')}}
                </div>
                <cloud-select ref="cloudSelect"  @changeOption="onChangeOption" :widthVal="300"
				 :selectOption="selectOption" :placeholder="selectValue" style="margin:0 !important;float:left">
                 </cloud-select>
                 <input type="text" style="width:100%;marginBottom:10Px;" v-if="emailInputShow" :placeholder="$t('language.twoStepverification.enterEmail')" class="ftp-cont-right-one"  v-model="emailValue">
                 <cloud-select ref="phoneSelect" @deleteSelectOption="showOtherOptions"  v-if="!emailInputShow"  @changeOption="onChangePhoneOption" :widthVal="300"
				 :selectOption="selectPhoneOption" :placeholder="selectPhoneValue" style="margin:10Px 0 0 0;float:left">
                  </cloud-select>
                  <input type="text" style="width:100%;marginBottom:10Px;" v-if="!emailInputShow" :placeholder="$t('language.twoStepverification.enterPhone')" class="ftp-cont-right-one"  v-model="phoneValue">
                  <div v-if="!emailInputShow" class="turnstile-container" ref="turnstileContainer">
                  </div>
                  <div style="color:red;fontSize:14px;float:left;text-algin:left;" v-if="isShowTipByPhoneValue">{{$t('language.twoStepverification.phoneValueTips')}}</div>
                  <div style="color:red;fontSize:14px;float:left;text-algin:left;" v-if="errorShow">{{errorTxt}}</div>
              </div>
              <div style="width:100%;height:30Px;float:left;">
                   <button style="float:right;width:110Px;" @click="sendCode()">{{$t('language.popup.reportPopup.next')}}</button>
              </div>
           </div>
            <div v-if="stepTwoShow" class="set-body-content">
                <div style="width:100%;height:calc(100% - 30Px);float:left;">
                <div style="float:left;width:100%;fontSize:14Px;lineHeight:20Px;">
                {{$t('language.twoStepverification.enterCode')}} <b v-if="emailValue" :title="emailValue">{{emailValue|ellipsisNavi}}</b><b v-if="phoneValue" :title="phoneValue">{{phoneValue|ellipsisNavi}}</b>
                </div>
                <input type="text" style="width:100%;marginBottom:10Px;position:relative;" :style="{top:getTopPx()}" placeholder="Code" class="ftp-cont-right-one"  v-model="code">
                <div v-if="emailValue" style="float:left;width:100%;fontSize:13Px;lineHeight:20Px;">
                    {{$t('language.twoStepverification.enterCodeTip')}}
                </div>
              </div>
              <div style="width:100%;height:30Px;float:left;">
                   <button style="float:right;width:110Px;" @click="vrificationCode()">{{$t('language.popup.reportPopup.next')}}</button>
              </div>
           </div>
             <div v-if="stepThreeShow" class="set-body-content">
                <div style="width:100%;height:calc(100% - 30Px);float:left;">
                     <div style="float:left;height:20Px;width:100%;fontSize:14Px;">
                          <b>{{$t('language.twoStepverification.verificationTurnOn')}}</b>
                     </div>
                     <div style="float:left;color:#6f7886;fontSize:14Px;marginTop:10Px;">{{$t('language.twoStepverification.recoverAccess')}}</div>
                     <div style="float:left;color:#6f7886;fontSize:14Px;marginTop:10Px;">{{$t('language.twoStepverification.longValid')}}</div>
                     <div style="float:left;color:#6f7886;fontSize:14Px;width:100%;marginTop:10Px;">{{$t('language.twoStepverification.newCode')}}</div>
                     <div style="float:left;fontSize:14Px;marginTop:10Px;corlor:#000;"><b>{{recoveyCode}}</b></div>
               </div>
              <div class="buttom-button">
                  <div style="width:100%">
                   <button class="button-finish" @click="finish()">{{$t('language.twoStepverification.finish')}}</button>
                   <button :style="{width:getCodeWidth()}" @click="copyCode($event)">{{$t('language.twoStepverification.copyCode')}}</button>
                  </div>
              </div>
              
           </div>
     </div>
</div>
</template>
<script>
import cloudSelect from "@/components/common/select/set_cloud_select";
import areaCodeUtil from "../../../js/workspace/area_code_utils.js";
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";

const TURNSTILE_SCRIPT_ID = 'cloudflare-turnstile-script';
const TURNSTILE_SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
let turnstileScriptPromise = null;

function loadTurnstileScript() {
    if (window.turnstile) {
        return Promise.resolve(window.turnstile);
    }
    if (turnstileScriptPromise) {
        return turnstileScriptPromise;
    }

    turnstileScriptPromise = new Promise((resolve, reject) => {
        let script = document.getElementById(TURNSTILE_SCRIPT_ID);
        const onLoad = () => {
            if (!window.turnstile) {
                turnstileScriptPromise = null;
                reject(new Error('Turnstile API is unavailable'));
                return;
            }
            resolve(window.turnstile);
        };
        const onError = () => {
            turnstileScriptPromise = null;
            if (script && script.parentNode) {
                script.parentNode.removeChild(script);
            }
            reject(new Error('Failed to load Turnstile API'));
        };

        if (script) {
            script.addEventListener('load', onLoad, { once: true });
            script.addEventListener('error', onError, { once: true });
            return;
        }

        script = document.createElement('script');
        script.id = TURNSTILE_SCRIPT_ID;
        script.src = TURNSTILE_SCRIPT_URL;
        script.async = true;
        script.defer = true;
        script.addEventListener('load', onLoad, { once: true });
        script.addEventListener('error', onError, { once: true });
        document.head.appendChild(script);
    });
    return turnstileScriptPromise;
}

export default {
    data() {
        return {
            cornet:'61',//区号
            user:commonUtils.getUser(),
            source:null,//打开该界面的来源
            stepOneShow:true,
            stepTwoShow:false,
            stepThreeShow:false,
            verifiSettingShow:false,
            userDevices:[],//用户现在已经绑定的设备
            emailValue:null,
            phoneValue:null,
            emailInputShow:true,
            code:null,
            selectValue:this.$t('language.twoStepverification.addAlEmail'),
            selectOption:[
					{
						name: this.$t('language.twoStepverification.addPhone'),
						icon: false,
						id: 1
					}],
		    selectOptionAll: [{
						name:this.$t('language.twoStepverification.addAlEmail'),
						icon: false,
						id: 0
					}, {
						name: this.$t('language.twoStepverification.addPhone'),
						icon: false,
						id: 1
					},				
				],
            onChangePhoneAllOption:areaCodeUtil.areacode,
            selectPhoneOption:[],//可供选择的项
            // selectPhoneValue:'United States(+1)',
            selectPhoneValue:'Australia(+61)',
            deleteOption:null,
            recoveyCode:'7234T-GWXBK-3A8GC-2KRR4-KXD2T',
            errorShow:false,
            errorTxt:'',
            phoneCurrentValue:null,//电话号码选中
            isShowTipByPhoneValue: false,//通过地区判断是否需要展示提示
            turnstileToken: '',
            turnstileWidgetId: null,
            turnstileWaiting: false,
        }
    },
    watch:{
        emailInputShow(newValue,oldValue){
         if(!newValue){
             var that = this;
             this.$nextTick(()=>{
                 if(that.$refs.phoneSelect && that.phoneCurrentValue){
                    that.$refs.phoneSelect.currentValue = that.phoneCurrentValue;
               }
               that.renderTurnstile();
             });
         }else{
             this.removeTurnstile();
         }
        },
        verifiSettingShow(newValue,oldValue){
            if(newValue){
            this.errorShow=false;
            this.stepOneShow=true;
            //进入到第二步
            this.stepTwoShow=false;
            this.stepThreeShow=false; 
            //var currentValue;
            let that=this;
            that.selectPhoneOption = Object.assign([],areaCodeUtil.areacode);
            if(this.source!='update'){
             if(that.$refs.phoneSelect){
                that.phoneCurrentValue = that.$refs.phoneSelect.currentValue;
             }
            areaCodeUtil.getAreacode(function(res){
            if(res.cornet){
            // that.cornet=res.cornet;
            if (res.cornet != 1) {
                that.cornet=res.cornet;
            }
            $.each(that.selectPhoneOption,function(i,item){
              if(res.cornet==1 && item.value==61 && item.name=='Australia(+61)'){
                that.selectPhoneValue = item.name;
                that.phoneCurrentValue = item.name;
                that.selectPhoneOption.splice(i,1);
                return false;
             }
              // if(res.cornet==1 && res.cornet== item.value && item.name=='United States(+1)'){
              //   that.selectPhoneValue = item.name;
              //   that.phoneCurrentValue = item.name;
              //   that.selectPhoneOption.splice(i,1);
              //   return false;
              // }
             if(item.value == res.cornet &&res.cornet!=1){
               that.selectPhoneValue = item.name;
               that.phoneCurrentValue = item.name;
               that.selectPhoneOption.splice(i,1);
               return false;
             }
            });
            }
            });
            }else{
            that.phoneCurrentValue = null;
            $.each(that.selectPhoneOption,function(i,item){
              // if(that.cornet==1 && that.cornet== item.value && item.name=='United States(+1)'){
              //   that.selectPhoneValue = item.name;
              //   that.selectPhoneOption.splice(i,1);
              //   return false;
              // }
             if(item.value == that.cornet &&that.cornet!=1){
               that.selectPhoneValue = item.name;
                if(that.$refs.phoneSelect){
                 that.$refs.phoneSelect.currentValue = that.selectPhoneValue;
                }
               that.selectPhoneOption.splice(i,1);
               return false;
             }
            });

            }

            if (!this.emailInputShow) {
                this.$nextTick(() => this.renderTurnstile());
            }
            }else{
                this.removeTurnstile();
            }
        },
        cornet(newValue,oldValue){
            if(newValue==44) {
                //如果是英国地区，需要增加提示
                this.isShowTipByPhoneValue = true;
            }else {
                //否则去除提示
                this.isShowTipByPhoneValue = false;
            }
        },
    },
    filters:{
             ellipsisNavi(value) {
            let subStr;
            if (!value) return '';
            if (value.length >22) {
                subStr = value.slice(0, 22) + '...';
            } else {
                subStr = value;
            }
            return subStr;
        }
    },
    components:{
        "cloud-select": cloudSelect,
    },
    beforeDestroy() {
        this.removeTurnstile();
    },
    methods: {
        getCodeWidth(){
            let width=110+'px';
            switch (this.$i18n.locale) {
            case 'deutsch':
                width=120+'px';
                return width;
                break;
            case 'france':
                width=120+'px';
                return width;
                break;
            case 'portuguese':
                width=120+'px';
                return width;
                break;
            case 'spanish':
                width=125+'px';
                return width;
                break;
            case 'italian':
                width=120+'px';
                return width;
                break;
            case 'japanese':
                width=120+'px';
                return width;
                break;
            case 'traditionalChinese':
                width=120+'px';
                return width;
                break;
            case 'chinese':
                 width=120+'px';
                return width;
                break;
        }
        },
        getheight(){
            let height;
            if(this.stepThreeShow){
               height='370Px';
            }else if(this.stepOneShow && !this.emailInputShow){
               height='450Px';
            }
            return height;
        },
        renderTurnstile(){
            if(!this.verifiSettingShow || this.emailInputShow) return;
            loadTurnstileScript().then(turnstile => {
                if(!this.verifiSettingShow || this.emailInputShow || !this.$refs.turnstileContainer
                    || this.turnstileWidgetId !== null) return;
                this.turnstileWidgetId = turnstile.render(this.$refs.turnstileContainer, {
                    sitekey: commonstate.turnstileSiteKey,
                    action: 'dual_verify_sms',
                    size: 'flexible',
                    appearance: 'always',
                    theme: 'light',
                    callback: token => {
                        this.turnstileToken = token;
                    },
                    'expired-callback': () => this.resetTurnstile(),
                    'timeout-callback': () => this.resetTurnstile(),
                    'error-callback': () => {
                        this.turnstileToken = '';
                    }
                });
            }).catch(error => {
                this.turnstileToken = '';
                console.warn('Turnstile initialization failed:', error.message);
            });
        },
        resetTurnstile(){
            this.turnstileToken = '';
            if(window.turnstile && this.turnstileWidgetId !== null){
                try {
                    window.turnstile.reset(this.turnstileWidgetId);
                } catch (error) {
                    console.warn('Turnstile reset failed:', error.message);
                }
            }
        },
        removeTurnstile(){
            this.turnstileToken = '';
            if(window.turnstile && this.turnstileWidgetId !== null){
                try {
                    window.turnstile.remove(this.turnstileWidgetId);
                } catch (error) {
                    console.warn('Turnstile removal failed:', error.message);
                }
            }
            this.turnstileWidgetId = null;
        },
        waitForTurnstileToken(timeout){
            const maxWait = timeout || 5000;
            const startedAt = Date.now();
            return new Promise(resolve => {
                const checkToken = () => {
                    if(this.turnstileToken || !this.verifiSettingShow || this.emailInputShow
                        || Date.now() - startedAt >= maxWait){
                        resolve(this.turnstileToken);
                        return;
                    }
                    setTimeout(checkToken, 100);
                };
                checkToken();
            });
        },
        getTopPx(){
             var top=0;
            switch (this.$i18n.locale) {
            case 'italian':
                top=15+'Px'
                return top;
                break;
             case 'portuguese':
                top=15+'Px'
                return top;
                break;
            case 'france':
                top=15+'Px'
                return top;
                break;
             case 'deutsch':
                top=15+'Px'
                return top;
                break;
          }
        },
        closePage(){
            this.verifiSettingShow=false;
            this.emailValue = null;
            this.phoneValue = null;
            this.removeTurnstile();
        },
        showOtherOptions(index){
             //删除某一项的下标
           	if (this.deleteOption && this.deleteOption.length > 0) {
					this.selectPhoneOption.splice(this.deleteOption[0].id, 0, {
						id: this.deleteOption[0].id,
						name: this.deleteOption[0].name
					});
					if (this.deleteOption[0].id <= index) {
						this.deleteOption = this.selectPhoneOption.splice(index + 1, 1);
					} else {
						this.deleteOption = this.selectPhoneOption.splice(index, 1);
					}
				} else {
					this.selectPhoneOption.splice(0, 0, {
						id: 0,
						name: this.selectPhoneValue,
                        value: this.cornet
					});
					this.deleteOption = this.selectPhoneOption.splice(index + 1, 1);
				}
				this.$forceUpdate();
        },
        //更改用户后，返回newValue
        onChangeOption(newValue){
             this.selectOption = Object.assign([], this.selectOptionAll);
             this.$refs.cloudSelect.$refs.sel.style.width =400+'Px';
             switch (newValue.replace(/^\s+|\s+$/g, "")) {
                 case this.$t('language.twoStepverification.addPhone'):
                       //this.selectPhoneOption = Object.assign([],areaCodeUtil.areacode);   
                       this.selectOption.splice(1, 1);
                       this.emailInputShow=false;
                       if(this.deleteOption && this.deleteOption.length){
                           this.selectPhoneValue = this.deleteOption[0].name;
                       }
                       this.emailValue=null;
                       break;
                 case this.$t('language.twoStepverification.addAlEmail'):
                       this.selectOption.splice(0, 1);
                       this.emailInputShow=true;
                       this.phoneValue=null;
                       break;  
             }
        },
        onChangePhoneOption(newValue){
            let cornet = newValue.split("+")[1];
            this.cornet=cornet.split(')')[0];
            //console.log('新的区号'+this.cornet);
        },
        sendCode(skipTurnstileWait){
            //发送验证码
           let that = this;
         //执行下一步操作
           if (this.emailInputShow){
                if(!this.emailValue){
                    this.$toast({
                        text: this.$t('language.exception.emailEmpty'),
                        type: 'fail',
                        idValue: "verificationSet"
                    });
                    return false;
                }
                if(this.emailValue.indexOf('@') == -1){
                     this.$toast({
                    text: this.$t('language.login.enterCorrectEmai'),
                    type: 'fail',
                    idValue: "verificationSet"
                   });
                  return false;
                }
                if(!commonstate.emailpattern.test(this.emailValue) && this.emailValue) {
                this.$toast({
                    text: this.$t('language.login.enterCorrectEmai'),
                    type: 'fail',
                    idValue: "verificationSet"
                });
                return false;
                }
                this.phoneValue=null;
                this.Utils.doDualVerifyRequest('send',{userId:this.user.id,email:this.emailValue}).then(res=>{
                     if(res.status==200){
                          that.stepOneShow=false;
                           //进入到第二步
                          that.stepTwoShow=true;
                          that.code=null; 
                     }else{
                        if(res.reason == 'sendTooOften' || res.reason == 'hour24Limit'){
                            that.errorShow=true;
                            that.errorTxt =that.$t('language.twoStepverification.toManyCodeSend');
                            return;
                        }
                        that.$toast({
                        text: that.$t('language.exception.'+res.reason),
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                    return false;
                     }
                });
           }else{
                if(!this.phoneValue){
                    this.$toast({
                        text: this.$t('language.twoStepverification.phoneNotEmpty'),
                        type: 'fail',
                        idValue: "verificationSet"
                    });
                    return false;
                 }
                if(!this.turnstileToken && !skipTurnstileWait){
                    if(this.turnstileWaiting) return;
                    this.turnstileWaiting = true;
                    this.waitForTurnstileToken(3000).then(() => {
                        this.turnstileWaiting = false;
                        if(this.verifiSettingShow && !this.emailInputShow){
                            this.sendCode(true);
                        }
                    });
                    return;
                }
                 let sendData={
                     userId:this.user.id,
                     cornet:this.cornet,
                     phoneNumber:this.phoneValue
                 }
                if(this.turnstileToken){
                    sendData.turnstileToken = this.turnstileToken;
                }
                this.emailValue="";
                this.Utils.doDualVerifyRequest('send',sendData).then(res=>{
                    that.resetTurnstile();
                     if(res.status==200){
                          that.stepOneShow=false;
                           //进入到第二步
                          that.stepTwoShow=true;
                          that.code=null;
                     }else{
                         if(res.reason == 'sendTooOften' || res.reason == 'hour24Limit'){
                            that.errorShow = true;
                            that.errorTxt = that.$t('language.twoStepverification.toManyCodeSend');
                            return;
                        }
                        if(res.reason == 'turnstileInvalid'){
                            that.errorShow = true;
                            that.errorTxt = res.message || res.msg;
                            return;
                        }
                        that.$toast({
                        text: that.$t('language.exception.'+res.reason),
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                    return false;
                     }
                }, () => {
                    that.resetTurnstile();
                });

           }
      
           
        },
        vrificationCode(){
             let that=this;
             if(this.userDevices[0] && this.phoneValue){
               that.source == 'update';
             }
              if(this.userDevices[1] && this.emailValue){
               that.source == 'update';
             }
             //验证验证码是否正确
             if(that.source != 'update'){
                 let createData;
                 if(this.code){
                     this.code = this.code.trim();
                 }else{//如果没输验证码则报错
                      that.$toast({
                        text: that.$t('language.login.exception.codeEmpty'),
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                       return false;
                 }
                if(this.emailValue){
                     createData={
                      userId:this.user.id,
                      email:this.emailValue,
                      verificationCode:this.code
                    }
                }else{
                     createData={
                      userId:this.user.id,
                      phoneNumber:this.phoneValue,
                      cornet:this.cornet,
                      verificationCode:this.code
                    }
                }
           
             if(that.source == 'addTrust'){
                that.verifyChange(function(){
                      that.verifiSettingShow=false;
                      return;
                }); 
                return;
             }
             this.Utils.doDualVerifyRequest('create',createData).then(res=>{
                  if(res.status == 200){
                      that.recoveyCode = res.recoverCode;
                      that.stepOneShow = false;
                      that.stepTwoShow = false;
                      that.stepThreeShow = true;  
                      that.userDevices = [that.phoneValue,that.emailValue];                
                  }else{
                      that.$toast({
                        text: that.$t('language.exception.'+res.reason),
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                       return false;
                  }
             });
             }else{
                 //如果是进行修改设备操作
                 this.verifyChange(function(){});
             }
        },
        blur(){
            this.errorTxt=null;
        },
        // addTrusted(callback){
        //     let that =this;
        //     let trustData={
        //         userId:this.user.id,
        //         trustedDevice:this.code
        //     }
        //     this.Utils.doDualVerifyRequest('trusted',trustData).then(res=>{
        //         that.getVerifyInfo();
        //         callback(res);
        //     });
        // },
        verifyChange(callback){
            let that = this;
            let changeData;
            if(this.code){
                this.code = this.code.trim();
            }else{
                  that.$toast({
                        text: that.$t('language.login.exception.codeEmpty'),
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                       return false;
            }
            if(this.emailValue){
              changeData={
                userId:this.user.id,
                email:this.emailValue,
                verificationCode:this.code,
            }
            }else{
                changeData={
                userId:this.user.id,
                phoneNumber:this.phoneValue,
                cornet:this.cornet,
                verificationCode:this.code,
            }
            }
            this.Utils.doDualVerifyRequest('change',changeData).then(res=>{
                if(res.status==200){
                that.getVerifyInfo();
                that.userDevices = [that.phoneValue,that.emailValue];     
                that.verifiSettingShow=false;
                callback(res);
                }else{
                        that.$toast({
                        text: res.msg,
                        type: 'fail',
                        idValue: "verificationSet"
                        });
                    return false;
                }
            }); 
        },
        finish(){
             let that=this;
             that.getVerifyInfo();
             this.verifiSettingShow=false;
        },
        getVerifyInfo(){
               let that=this;
               let self=that.$parent.$refs.updateVerificationDialog;
               this.Utils.doDualVerifyRequest('get',{userId:this.user.id}).then(res=>{
                 self.updateVerifiShow=true;
                 self.verificationStatus=res.status;
                 self.emialValue=res.devices[1];
                 self.phoneValue=res.devices[0];
                 if(!self.phoneValue){
                     self.txtShow=false;
                 }else{
                   if(self.phoneValue && self.phoneValue.indexOf("-")!=-1){
                   let index = self.phoneValue.indexOf("-");
                   self.cornet = self.phoneValue.substring(0,index);
                   self.phoneValue = self.phoneValue.substring(index+1);
                    }
                     self.txtShow=true;
                 }
                 if(!self.emialValue){
                     self.emialShow=false;
                 }else{
                     self.emialShow=true;
                 }
                
             });
        },
        copyCode(e){
        const clipboard = new this.clipboard(e.target, {
          text: () => this.recoveyCode
        });
        clipboard.on('success', e => {
          this.$toast({
            text: this.$t('language.twoStepverification.codeCopied'),
            type: 'success',
            idValue: "verificationSet"
          });
        })
        clipboard.on('error', e => {
          clipboard.off('error');
          clipboard.off('success');
        })
        clipboard.onClick(e);
        }
    },

}
</script>

<style>
#verificationSet{
    width: 440Px;
    height: 370Px;
}
.set-body-content{
    width: 100%;
    height: calc(100% - 40Px);
    box-sizing: border-box;
    padding: 30Px 20Px 20Px 20Px;
}
.buttom-button{
    width:100%;
    height:30Px;
    display:flex;
    align-items: center;
    text-align: center;
}

.button-finish, .button-finish:hover{
width:110Px;
margin-right:10px;
color:#5562b4;
background:#fff;
border: 1Px solid #5562b4;
}

.turnstile-container {
    clear: both;
    display: flex;
    justify-content: center;
    width: 100%;
    margin-bottom: 10Px;
}

.turnstile-container > div {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/verification_setting_popup.vue